import { g as r } from "../../utils-BOfnFgIH.js";
import { I as i } from "../../constants-DeVuDy8J.js";
import { createElementBlock as n, openBlock as s, normalizeClass as d, createElementVNode as a } from "vue";
import { _ as o } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const c = {
  name: "DtIconTransferWebchat",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (e) => Object.keys(i).includes(e)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return i[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded"), this.uniqueID = r();
  }
}, h = ["aria-label", "data-qa", "aria-hidden"], _ = ["clip-path"], u = /* @__PURE__ */ a("path", {
  "fill-rule": "evenodd",
  d: "M6.706 3.5a.5.5 0 0 1 .5-.5h2.905a1.39 1.39 0 0 1 1.39 1.386v4.427a1.384 1.384 0 0 1-1.39 1.385H5.192a.502.502 0 0 0-.354.146l-.916.913c-.522.52-1.422.155-1.422-.59v-2.48a.5.5 0 1 1 1 0v2.079l.632-.63c.282-.28.663-.438 1.06-.438h4.92a.39.39 0 0 0 .275-.113.384.384 0 0 0 .113-.272V4.386c0-.102-.04-.2-.113-.272A.39.39 0 0 0 10.111 4H7.206a.5.5 0 0 1-.5-.5Z",
  "clip-rule": "evenodd"
}, null, -1), f = /* @__PURE__ */ a("path", { d: "M3.897 1.147a.5.5 0 0 1 .707 0l1.25 1.25a.5.5 0 0 1 0 .707l-1.25 1.25a.5.5 0 0 1-.707-.707l.396-.397H2.5a.5.5 0 0 1 0-1h1.793l-.396-.396a.5.5 0 0 1 0-.707Zm-1.293 2.5a.5.5 0 0 1 0 .707l-.397.396H4a.5.5 0 1 1 0 1H2.207l.397.397a.5.5 0 0 1-.707.707l-1.25-1.25a.5.5 0 0 1 0-.707l1.25-1.25a.5.5 0 0 1 .707 0Z" }, null, -1), m = [
  u,
  f
], p = ["id"], g = /* @__PURE__ */ a("path", {
  fill: "#fff",
  d: "M0 0h12v12H0z",
  transform: "matrix(1 0 0 -1 0 12)"
}, null, -1), v = [
  g
];
function b(e, I, l, H, q, t) {
  return s(), n("svg", {
    "aria-label": l.ariaLabel,
    class: d([t.iconSizeClass, "d-icon d-icon--transfer-webchat"]),
    "data-qa": t.dataQA,
    "aria-hidden": t.ariaHidden,
    role: "img",
    "data-name": "Transfer Webchat",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 12"
  }, [
    a("g", {
      "clip-path": `url(#${e.uniqueID}a)`,
      fill: "currentColor"
    }, m, 8, _),
    a("defs", null, [
      a("clipPath", {
        id: `${e.uniqueID}a`
      }, v, 8, p)
    ])
  ], 10, h);
}
const D = /* @__PURE__ */ o(c, [["render", b]]);
export {
  D as default
};
//# sourceMappingURL=transfer-webchat.js.map
